import React from 'react';
import { Modal, Button } from 'react-bootstrap';

const LogoutModal = ({ show, handleClose, handleLogout }) => {
    return (
        <Modal show={show} onHide={handleClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>Confirmación de Salida</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                ¿Estás seguro de que deseas salir?
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Cancelar
                </Button>
                <Button variant="danger" onClick={handleLogout}>
                    Salir
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default LogoutModal;
